<template>
  <div style="width: 100%;height: 100%;">
    <imagesChart :width="width" :screen="screen" :page="page" :height="height" :chartConfig="chartConfig"></imagesChart>
  </div>
</template>
<style>
</style>
<script>
  import imagesChart from './components/images.vue'
  export default {
    props: {
      width: {
        type: String,
        default: '300px'
      },
      height: {
        type: String,
        default: '30px'
      },
      screen: {
        type: Object,
        default () {
          return {
            height: 1920,
            width: 1280
          }
        }
      },
      page: {
        type: Object,
        default () {
          return {
            height: 1920,
            width: 1280,
          }
        }
      },
      chartConfig: {
        type: Object,
        default: function() {
          return {
            uploadUrl: '',
            authorization: '',
            imageId: '',
            isOpen: '0',
            btnLocation: null,
            title: '',
            formTitle:'窗口',
            list: [],
            btnLocation:null,
            dialogWidth:'500px',
            dialogHeight:'500px',
            image: null
          }
        }
      }
    },
    components: {
      imagesChart,
    }

  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/images/image/index.vue